import { Chip } from "@mui/material";

type Props = {
  label: string;
};

export const RoomFacilityChip = ({ label }: Props) => (
  <Chip
    label={label}
    size="small"
    sx={{
      backgroundColor: "var(--color-surface-background)",
      borderRadius: "var(--radius-lg)",
      color: "var(--color-text-primary)",
    }}
  />
);
